module.exports = function() {
  return new Worker(__webpack_public_path__ + "d24bc77d92da5f966c7c.worker.js");
};